import { Text } from "~/components/text";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

export function FilterSectionAction({
  label,
  disabled,
  disabledTooltip,
  testId,
  onClick,
}: {
  label: string;
  disabled?: boolean;
  disabledTooltip?: string;
  testId?: string;
  onClick: () => void;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>
          <button
            type="button"
            disabled={disabled}
            data-testid={testId}
            className="text-sm font-medium text-primary-600 hover:text-primary-700 disabled:text-secondary-400 disabled:cursor-not-allowed"
            onClick={onClick}
          >
            {label}
          </button>
        </span>
      </TooltipTrigger>
      {disabled && disabledTooltip && (
        <TooltipContent
          side="bottom"
          className="text-left shadow-tooltip text-secondary-600 whitespace-normal z-10 border-none max-w-xs"
          sideOffset={6}
        >
          <TooltipArrow
            className="fill-white drop-shadow-xs"
            width={12}
            height={6}
          />
          <Text variant="body">{disabledTooltip}</Text>
        </TooltipContent>
      )}
    </Tooltip>
  );
}
